import store from '@/store/index'
import Roles from "@/constants/roles";

export default {
    loggedIn() {
        return !!store.state.user;
    },
    hasRole(role) {
        if (!store.state.user) {
            return false
        }
        if (Array.isArray(role)) {
            let has = false;
            _.forEach(role, item => {
                if (!!store.state.user.roles.find(i => i.name === item)) {
                    has = true;
                    return false
                }
            });
            return has;
        }
        return !!store.state.user.roles.find(item => {
            return item.name === role
        })
    },
    hasDealerOrManagerRole() {
        return this.hasRole(
            [
                Roles.dealer_principle,
                Roles.sales_manager
            ]
        )
    }
}
